<pl-video
  *ngIf="block"
  [poster]="block.data.poster"
  [sourceHD]="block.data.source_hd"
  [sourceSD]="block.data.source_sd"
  [captions]="block.data.captions"
/>
